import React from "react";

import ChevronBigDown from "@tiny/icons/generated/ChevronBigDown";
import ChevronBigUp from "@tiny/icons/generated/ChevronBigUp";
import useForwardRef from "../hooks/useForwardRef";
import useId from "../hooks/useId";
import Button from "../Button";
import Menu from "../Menu";
import { MenuButtonProps } from "./MenuButton.types";
import { useStyles } from "./MenuButton.styles";
import {
  anchorOriginDefault,
  transformOriginDefault,
} from "./MenuButton.helpers";

const TOTAL_MENU_PADDING_X = 24;

function MenuButton(
  props: MenuButtonProps,
  ref: React.ForwardedRef<HTMLButtonElement>
) {
  const {
    anchorOrigin = anchorOriginDefault,
    children,
    text,
    onClick,
    transformOrigin = transformOriginDefault,
    size,
    ...other
  } = props;

  const classes = useStyles();

  const buttonRef = useForwardRef(ref);

  const menuId = useId();

  const [open, setOpen] = React.useState(false);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setOpen(true);
    onClick?.(event);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button {...other} ref={buttonRef} size={size} onClick={handleClick}>
        {text}
        {open ? (
          <ChevronBigUp className={classes.arrow} />
        ) : (
          <ChevronBigDown className={classes.arrow} />
        )}
      </Button>
      <Menu
        size={size}
        anchorEl={buttonRef.current}
        anchorOrigin={anchorOrigin}
        disableScrollLock
        id={menuId}
        onClose={handleClose}
        open={open}
        transformOrigin={transformOrigin}
        onClick={handleClose}
        MenuListProps={{
          style: {
            minWidth: buttonRef.current
              ? buttonRef.current.clientWidth - TOTAL_MENU_PADDING_X
              : undefined,
          },
        }}
      >
        {children}
      </Menu>
    </>
  );
}

export default React.forwardRef(MenuButton);
